// extracted by mini-css-extract-plugin
module.exports = {"boxBtn":"_3in3HSxKg6wm83nH4SfeXz","boxSwitch":"_1YOAr4U9WVTQLqCsWiI9XS","btnView":"_1vY1G2HFP4AxBzMrLLyV_-","btnEdit":"_2fdeYyBfjuA0G_oMEjMzpu"};